<template>
<div class="main-container">
  <div v-if="showIntro && !gradesData[le_id]">
    <tl-header type="h1">Grades and Designation</tl-header>
    <div class="row-container center">
      <div class="company-info">
        <img class="image" src="@/assets/salaryGrades.svg" />
        <div class="fontStyle">
          <!-- <div @click="goToSalaryGradesPage"><img class="closeImage" src="@/assets/close.png" /></div> -->
          <br><br><span>A salary grade is a predetermined compensation level for a
            given position within an organisation. The level is expressed through a
          </span><span><br> salary range and typically the levels are set at each
            individual business entity.</span><br><br>

          <span>For example, the salary grade for mid-level management
            positions at ABC Inc. may be different from
            the salary grades of XYZ Inc.</span><br>
          <span>
            When setting salary grade, company executives,
            hiring managers and other relevant parties will discuss the
            possible skill levels and credentials of professional likely
            to be hired for a given position. The salary grades are
            frequently meant to be competitive while</span><br>
          <span>giving the employer room to negotiate.</span><br><br>
          <div class="divider"></div><br><br>
          <btn text="Get Started" type="secondary" @click="goToSalaryGradesPage" />
        </div>
      </div>
    </div>

    <bottom-action-container class="placeAtEnd">
      <!-- <template slot="end">
        <btn-skip @navClicked="navHandler"></btn-skip>
      </template> -->
    </bottom-action-container>
  </div>
  <div v-else>
    <grades @displayIntro="goToIntro" />
  </div>
</div>
</template>

<script>
// import SalaryGrades from './crud_salary_grades.vue';
import Grades from './Grades.vue'
import {
  mapState,
  mapActions,
  mapGetters
} from 'vuex';
export default {
  name: 'SalaryGradesIntro',
  data() {
    return {
      showIntro: true
    }
  },
  components: {
    Grades
  },
  activated:function(){
      this.fetchGrades();
  },
  computed: {
    ...mapState('onboard/salary_grades', {
      gradesData: state => state.data
    }),
     ...mapGetters({
       getleid:'onboard/legal_entities/legal_entity_ID'
    }),
    le_id(){
      if(this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index)
      else{
           return this.getleid(0)
      }
    }
  },
  methods: {
    ...mapActions({
      fetch: 'onboard/salary_grades/fetchAll'
    }),
    navHandler(navType) {
      this.$validator.reset();
      if (navType == 'back') {
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/costcenters`
        });
      }
      if (navType == 'next') {
        this.$validator.reset();
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/bands`
        });
      }
    },
    goToIntro() {
      this.showIntro = true;
    },
    goToSalaryGradesPage() {
      this.showIntro = false;
    },
    async fetchGrades() {
      try {
        await this.fetch(this.le_id);
      } catch (err) {
        //console.log(err);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.image {
  margin-top: 30px;
}

.row-container {
  .value {
    margin-right: 0;
  }
}

.company-info {
  display: flex;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  align-items: flex-start;
}

.closeImage {
  float: right;
  margin: -10px;
  cursor: pointer;
}

.building {
  width: 56px;
  height: 58px;
  object-fit: contain;
  margin: 25px 0 0 129px;
}

.fontStyle {
  margin-left: 20px;
  font-family: Montserrat;
  font-size: 16px;
  color: #404040;
}

.divider {
  color: #34c0be;
  border-bottom: 2px solid #34c0be;
  width: 60%;
  margin: 30px 0 0 5px;

}

.placeAtEnd {
  margin-top: 130px;
}
</style>
